import { useMemo } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { useRoutes } from "../app/routes";
import PuzzleFaces from "../assets/puzzle_faces.png";
import VisualFace from "../assets/visual_face.png";
import IdeaFace from "../assets/idea_face.png";
import s from "./identity.module.scss";

const Identity = () => {
  const { unAuthRoutes } = useRoutes();
  const welcomeComponent = useMemo(
    () => (
      <>
        <Typography className={s.titleText}>Welcome to Tapestry!</Typography>
        <Typography className={s.subtitleText}>Instantly create a visual story from your conversation</Typography>
        <div className={s.welcomeGrid}>
          <div className={s.welcomeRow}>
            <img
              src={PuzzleFaces}
              alt="puzzle faces"
              className={`${s.overlappingImage} ${s.puzzleFaces}`}
            />
            <Typography className={s.welcomeText}>Shared vision brings people together</Typography>
          </div>
          <div className={s.welcomeRow} style={{ paddingLeft: 92 }}>
            <img
              src={VisualFace}
              alt="seeing face"
              className={`${s.overlappingImage} ${s.visualFace}`}
            />
            <Typography className={s.welcomeText} style={{ maxWidth: "180px" }}>
              Words come alive with visual metaphors
            </Typography>
          </div>
          <div className={s.welcomeRow}>
            <img src={IdeaFace} alt="idea face" className={`${s.overlappingImage} ${s.ideaFace}`} />
            <Typography className={s.welcomeText}>Art makes ideas stick</Typography>
          </div>
        </div>
      </>
    ),
    []
  );

  const res = useMemo(() => {
    return window.location.href.indexOf("early") > -1 ? (
      <div className={s.scrollBox}>
        <Box className={s.innerBox}>
          <img src="/logo_with_text.png" className={s.logoImage} alt="Tapestry AI logo" />
          {unAuthRoutes()}
        </Box>
      </div>
    ) : (
      <div className={s.background}>
        <Box className={s.loginBox}>
          <Box className={s.innerBox}>
            <Grid container>
              <Grid item md={6} lg={6} className={s.welcomeComponent}>
                {welcomeComponent}
              </Grid>
              <Grid item md={6} lg={6}>
                <img src="/logo_with_text.png" alt="TapestryAI logo" />
                {unAuthRoutes()}
              </Grid>
            </Grid>
          </Box>
        </Box>
      </div>
    );
  }, [unAuthRoutes, welcomeComponent]);
  return res;
};

export default Identity;
